// import React, { useEffect, useRef, useState } from "react";
// import PropTypes from "prop-types";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchThingDetails } from "../../../../features/thing/thingThunk";
// import { setIsVehicle, resetIsVehicle } from "../../../../features/vehicle/vehicleSlice";
// import { fetchJourneys } from "../../../../features/journey/journeyThunk";
// import { fetchAccountGetData } from "../../../../features/accountGet/accountthunk";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import {
//   Autocomplete,
//   TextField,
//   Card,
//   CardContent,
//   Grid,
//   createFilterOptions,
//   Typography,
// } from "@mui/material";
// import { toast } from "react-toastify";

// const VehicleDetails = ({ onEditJourney, onClearJourney, externalHandles }) => {
//   const dispatch = useDispatch();

//   const { things = [] } = useSelector((state) => state.things || {});
//   const { data: journeysData = {} } = useSelector((state) => state.journey || {});

//   // const [selectedVehicle, setSelectedVehicle] = useState("");
//   const selectedVehicle = useSelector((state) => state.vehicle.isVehicle);
//   const wrapperRef = useRef(null);

//   useEffect(() => {
//     dispatch(fetchThingDetails());
//   }, [dispatch]);

//   useEffect(() => {
//     if (selectedVehicle) {
//       // console.log("Fetching journeys for:", selectedVehicle);
//       dispatch(fetchJourneys(selectedVehicle));
//       // dispatch(fetchAccountGetData());
//     }
//   }, [selectedVehicle, dispatch]);

//   const handleSelectVehicle = (event, newValue) => {
//     const selectedId = newValue ? newValue.id : "";
//     // setSelectedVehicle(selectedId);

//     onClearJourney();

//     if (selectedId) {
//       dispatch(setIsVehicle(selectedId));
//       dispatch(fetchJourneys(selectedId));
//       dispatch(fetchAccountGetData());
//     } else {
//       dispatch(resetIsVehicle());
//     }
//   };

//   const filterOptions = createFilterOptions({
//     stringify: (option) =>
//       `${option?.name || ""} ${option?.nickName || ""} ${option?.thingId || ""} ${option?.vehicleNumber || ""}`,
//   });

//   const handleSync = async () => {
//     if (!selectedVehicle) return;
//     try {
//       const res = await fetch(
//         `https://v3.dhundhoo.com/vendor/journeys/init/${selectedVehicle}`,
//         {
//           method: "GET",
//           headers: {
//             "x-dhundhoo-session": window.localStorage.getItem("token"),
//           },
//         }
//       );
//       if (res.ok) {
//         toast.success("Sync successful");
//         dispatch(fetchJourneys(selectedVehicle));
//       } else {
//         toast.error("Sync failed");
//       }
//     } catch (err) {
//       toast.error("Error during Sync");
//     }
//   };

//   const handleMigrate = async () => {
//     if (!selectedVehicle) return;
//     try {
//       const res = await fetch(
//         `https://v3.dhundhoo.com/vendor/migrate/journey/${selectedVehicle}`,
//         {
//           method: "GET",
//           headers: {
//             "x-dhundhoo-session": window.localStorage.getItem("token"),
//           },
//         }
//       );
//       if (res.ok) {
//         toast.success("Migration successful");
//       } else {
//         toast.error("Migration failed");
//       }
//     } catch (err) {
//       toast.error("Error during Migration");
//     }
//   };

//   const journeysList = selectedVehicle
//     ? (Array.isArray(journeysData.journeys)
//       ? journeysData.journeys.filter(
//         (j) =>
//           j.thingId?.toString() === selectedVehicle?.toString() ||
//           j.externalHandle?.toString() === selectedVehicle?.toString()
//       )
//       : [])
//     : [];

//   const tempData = Array.isArray(journeysData.tempJourneys)
//     ? journeysData.tempJourneys
//     : [];

//   const hasValidExternalHandle = externalHandles?.some(
//     (handle) => handle !== null && handle !== undefined
//   );

//   return (
//     <MDBox
//       sx={{
//         width: "100%",
//         height: "100%",
//         boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
//         backgroundColor: "#f5f7fa",
//         p: 2,
//         display: "flex",
//         flexDirection: "column",
//         borderRadius: "24px",
//       }}
//       ref={wrapperRef}
//     >
//       {/* --- FIXED SECTION (Search & Buttons) --- */}
//       <MDBox sx={{ mb: 2 }}>
//         <Typography variant="h6" mb={1}>
//           Select Vehicle
//         </Typography>
//         {/* <Autocomplete
//           options={things}
//           getOptionLabel={(option) =>
//             option?.name ? `${option.name} (${option.nickName || option.thingId})` : ""
//           }
//           value={selectedVehicle ? things.find((v) => v.id === selectedVehicle) || null : null}
//           onChange={handleSelectVehicle}
//           renderInput={(params) => (
//             <TextField {...params} placeholder="Select Vehicle" fullWidth size="small" />
//           )}
//           renderOption={(props, option) => (
//             <li
//               {...props}
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 width: "100%",
//               }}
//             >
//               <span>{option.name}</span>
//               <span style={{ color: "#666" }}>{option.nickName || option.thingId}</span>
//             </li>
//           )}
//         /> */}
//         <Autocomplete
//           options={things}
//           filterOptions={filterOptions}
//           getOptionLabel={(option) =>
//             option?.thingId ? `${option.thingId} (${option.nickName || option.thingId})` : ""
//           }
//           value={selectedVehicle ? things.find((v) => v.id === selectedVehicle) || null : null}
//           onChange={handleSelectVehicle}
//           renderInput={(params) => (
//             <TextField {...params} placeholder="Select Vehicle" fullWidth size="small" />
//           )}
//           renderOption={(props, option) => (
//             <li
//               {...props}
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 width: "100%",
//               }}
//             >
//               <span>{option.thingId}</span>
//               <span style={{ color: "#666" }}>{option.nickName || option.thingId}</span>
//             </li>
//           )}
//         />
//       </MDBox>

//       <MDBox sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <MDButton
//           variant="contained"
//           color="warning"
//           onClick={() => {
//             // setSelectedVehicle("");
//             dispatch(resetIsVehicle());
//             onClearJourney();
//           }}
//           disabled={things.length === 0}
//         >
//           CLEAR
//         </MDButton>

//         {/* {hasValidExternalHandle && ( */}
//         <MDButton
//           variant="contained"
//           color="warning"
//           onClick={handleSync}
//           disabled={!selectedVehicle}
//         >
//           SYNC
//         </MDButton>
//         {/* )} */}

//         {hasValidExternalHandle && (
//           <MDButton
//             variant="contained"
//             color="warning"
//             onClick={handleMigrate}
//             disabled={!selectedVehicle}
//           >
//             MIGRATE
//           </MDButton>
//         )}
//       </MDBox>

//       {/* --- SCROLLABLE SECTION (Cards) --- */}
//       <MDBox
//         sx={{
//           flex: 1, 
//           minHeight: 0,
//           overflowY: "auto",
//           msOverflowStyle: "none",
//           scrollbarWidth: "none",
//           "&::-webkit-scrollbar": {
//             display: "none",
//           },
//         }}
//       >
//         {selectedVehicle && journeysList.length > 0 ? (
//           journeysList.map((journey) => {
//             const tempMatch = tempData.find((t) => t.journeyId === journey.journeyId);
//             return (
//               <Card key={journey.journeyId} sx={{ mb: 2 }}>
//                 <CardContent>
//                   <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Typography variant="body1">Route: {journey.journeyName}</Typography>
//                     <Typography variant="caption">{journey.type}</Typography>
//                   </MDBox>
//                   <MDBox sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
//                     <Typography variant="caption">
//                       Stops: {journey.sequence ? Object.keys(journey.sequence).length : 0}
//                     </Typography>
//                     <Typography variant="caption">
//                       Passengers: {journey.infos ? Object.keys(journey.infos).length : 0}
//                     </Typography>
//                   </MDBox>
//                   <Grid container spacing={1} sx={{ mt: 1 }}>
//                     <Grid item xs={6}>
//                       <MDButton
//                         fullWidth
//                         variant="contained"
//                         color="warning"
//                         onClick={() => onEditJourney(journey)}
//                       >
//                         EDIT
//                       </MDButton>
//                     </Grid>
//                     <Grid item xs={6}>
//                       {tempMatch && (
//                         <MDButton
//                           fullWidth
//                           variant="contained"
//                           color="warning"
//                           onClick={() => onEditJourney(journey, tempMatch)}
//                         >
//                           PENDING
//                         </MDButton>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>
//             );
//           })
//         ) : (
//           <Typography variant="caption" color="textSecondary">
//             No journeys available
//           </Typography>
//         )}
//       </MDBox>
//     </MDBox>
//   );
// };

// VehicleDetails.propTypes = {
//   onEditJourney: PropTypes.func.isRequired,
//   onClearJourney: PropTypes.func.isRequired,
// };

// export default VehicleDetails;
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchThingDetails } from "../../../../features/thing/thingThunk";
import { setIsVehicle, resetIsVehicle } from "../../../../features/vehicle/vehicleSlice";
import { fetchJourneys } from "../../../../features/journey/journeyThunk";
import { fetchAccountGetData } from "../../../../features/accountGet/accountthunk";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import {
  Autocomplete,
  TextField,
  Card,
  CardContent,
  Grid,
  createFilterOptions,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";

const VehicleDetails = ({ onEditJourney, onClearJourney, externalHandles }) => {
  const dispatch = useDispatch();

  const { things = [] } = useSelector((state) => state.things || {});
  const { data: journeysData = {} } = useSelector((state) => state.journey || {});

  // const [selectedVehicle, setSelectedVehicle] = useState("");
  const selectedVehicle = useSelector((state) => state.vehicle.isVehicle);
  const wrapperRef = useRef(null);

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  useEffect(() => {
    if (selectedVehicle) {
      // console.log("Fetching journeys for:", selectedVehicle);
      dispatch(fetchJourneys(selectedVehicle));
      dispatch(fetchAccountGetData());
    }
  }, [selectedVehicle, dispatch]);

  const handleSelectVehicle = (event, newValue) => {
    const selectedId = newValue ? newValue.id : "";
    // setSelectedVehicle(selectedId);

    onClearJourney();

    if (selectedId) {
      dispatch(setIsVehicle(selectedId));
      dispatch(fetchJourneys(selectedId));
      dispatch(fetchAccountGetData());
    } else {
      dispatch(resetIsVehicle());
    }
  };

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option?.name || ""} ${option?.nickName || ""} ${option?.thingId || ""} ${option?.vehicleNumber || ""}`,
  });

  const handleSync = async () => {
    if (!selectedVehicle) return;
    try {
      const res = await fetch(
        `https://v3.dhundhoo.com/vendor/journeys/init/${selectedVehicle}`,
        {
          method: "GET",
          headers: {
            "x-dhundhoo-session": window.localStorage.getItem("token"),
          },
        }
      );
      if (res.ok) {
        toast.success("Sync successful");
        dispatch(fetchJourneys(selectedVehicle));
      } else {
        toast.error("Sync failed");
      }
    } catch (err) {
      toast.error("Error during Sync");
    }
  };

  const handleMigrate = async () => {
    if (!selectedVehicle) return;
    try {
      const res = await fetch(
        `https://v3.dhundhoo.com/vendor/migrate/journey/${selectedVehicle}`,
        {
          method: "GET",
          headers: {
            "x-dhundhoo-session": window.localStorage.getItem("token"),
          },
        }
      );
      if (res.ok) {
        toast.success("Migration successful");
      } else {
        toast.error("Migration failed");
      }
    } catch (err) {
      toast.error("Error during Migration");
    }
  };

  const journeysList = selectedVehicle
    ? (Array.isArray(journeysData.journeys)
      ? journeysData.journeys.filter(
        (j) =>
          j.thingId?.toString() === selectedVehicle?.toString() ||
          j.externalHandle?.toString() === selectedVehicle?.toString()
      )
      : [])
    : [];

  const tempData = Array.isArray(journeysData.tempJourneys)
    ? journeysData.tempJourneys
    : [];

  const hasValidExternalHandle = externalHandles?.some(
    (handle) => handle !== null && handle !== undefined
  );

  return (
    <MDBox
      sx={{
        width: "100%",
        height: "100%",
        boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
        backgroundColor: "#f5f7fa",
        p: 2,
        display: "flex",
        flexDirection: "column",
        borderRadius: "24px",
      }}
      ref={wrapperRef}
    >
      {/* --- FIXED SECTION (Search & Buttons) --- */}
      <MDBox sx={{ mb: 2 }}>
        <Typography variant="h6" mb={1}>
          Select Vehicle
        </Typography>
        {/* <Autocomplete
          options={things}
          getOptionLabel={(option) =>
            option?.name ? `${option.name} (${option.nickName || option.thingId})` : ""
          }
          value={selectedVehicle ? things.find((v) => v.id === selectedVehicle) || null : null}
          onChange={handleSelectVehicle}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select Vehicle" fullWidth size="small" />
          )}
          renderOption={(props, option) => (
            <li
              {...props}
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>{option.name}</span>
              <span style={{ color: "#666" }}>{option.nickName || option.thingId}</span>
            </li>
          )}
        /> */}
        <Autocomplete
          options={things}
          filterOptions={filterOptions}
          getOptionLabel={(option) =>
            option?.thingId ? `${option.thingId} (${option.nickName || option.thingId})` : ""
          }
          value={selectedVehicle ? things.find((v) => v.id === selectedVehicle) || null : null}
          onChange={handleSelectVehicle}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select Vehicle" fullWidth size="small" />
          )}
          renderOption={(props, option) => (
            <li
              {...props}
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>{option.thingId}</span>
              <span style={{ color: "#666" }}>{option.nickName || option.thingId}</span>
            </li>
          )}
        />
      </MDBox>

      <MDBox sx={{ display: "flex", gap: 1, mb: 2 }}>
        <MDButton
          variant="contained"
          color="warning"
          onClick={() => {
            // setSelectedVehicle("");
            dispatch(resetIsVehicle());
            onClearJourney();
          }}
          disabled={things.length === 0}
        >
          CLEAR
        </MDButton>

        {/* {hasValidExternalHandle && ( */}
        <MDButton
          variant="contained"
          color="warning"
          onClick={handleSync}
          disabled={!selectedVehicle}
        >
          SYNC
        </MDButton>
        {/* )} */}

        {hasValidExternalHandle && (
          <MDButton
            variant="contained"
            color="warning"
            onClick={handleMigrate}
            disabled={!selectedVehicle}
          >
            MIGRATE
          </MDButton>
        )}
      </MDBox>

      {/* --- SCROLLABLE SECTION (Cards) --- */}
      <MDBox
        sx={{
          flex: 1, 
          minHeight: 0,
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {selectedVehicle && journeysList.length > 0 ? (
          journeysList.map((journey) => {
            const tempMatch = tempData.find((t) => t.journeyId === journey.journeyId);
            return (
              <Card key={journey.journeyId} sx={{ mb: 2 }}>
                <CardContent>
                  <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="body1">Route: {journey.journeyName}</Typography>
                    <Typography variant="caption">{journey.type}</Typography>
                  </MDBox>
                  <MDBox sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                    <Typography variant="caption">
                      Stops: {journey.sequence ? Object.keys(journey.sequence).length : 0}
                    </Typography>
                    <Typography variant="caption">
                      Passengers: {journey.infos ? Object.keys(journey.infos).length : 0}
                    </Typography>
                  </MDBox>
                  <Grid container spacing={1} sx={{ mt: 1 }}>
                    <Grid item xs={6}>
                      <MDButton
                        fullWidth
                        variant="contained"
                        color="warning"
                        onClick={() => onEditJourney(journey)}
                      >
                        EDIT
                      </MDButton>
                    </Grid>
                    <Grid item xs={6}>
                      {tempMatch && (
                        <MDButton
                          fullWidth
                          variant="contained"
                          color="warning"
                          onClick={() => onEditJourney(journey, tempMatch)}
                        >
                          PENDING
                        </MDButton>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            );
          })
        ) : (
          <Typography variant="caption" color="textSecondary">
            No journeys available
          </Typography>
        )}
      </MDBox>
    </MDBox>
  );
};

VehicleDetails.propTypes = {
  onEditJourney: PropTypes.func.isRequired,
  onClearJourney: PropTypes.func.isRequired,
};

export default VehicleDetails;